// style
import '../css/style.scss';
import 'swiper/css';

// components

function importAll(r) {
  r.keys().forEach(r);
}


import 'lite-youtube-embed/src/lite-yt-embed.js';
importAll(require.context('./../../assets/resource/fonts/', true, /\.(woff|woff2|eot|ttf|otf)$/));

importAll(require.context('./../../assets/css/ui/', true, /\.scss$/));

// Импортируем все файлы js и scss из каждой подпапки 'components'
importAll(require.context('./../../components', true, /\.js$/));
importAll(require.context('./../../components', true, /\.scss$/));

// Импортируем все файлы js и scss из каждой подпапки 'blocks'
importAll(require.context('./../../blocks', true, /\.js$/));
importAll(require.context('./../../blocks', true, /\.scss$/));

// Импортируем все файлы js и scss из каждой подпапки 'vacancies-page'
importAll(require.context('./../../assets/css/vacancies-page', true, /\.scss$/));
importAll(require.context('./vacancies-page', true, /\.js$/));

// Импортируем все файлы js и scss из каждой подпапки 'archive-page'
importAll(require.context('./../../assets/css/archive-page', true, /\.scss$/));

// Импортируем все файлы js папки 'utils'
importAll(require.context('./utils', true, /\.js$/));

//импортируем функции из папки functions
import './functions/init-favorite-product';
import './functions/init-paralax-component';
